
import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    age: '',
    inquiry_type: '一般お問い合わせ',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d35oh8u78msbhm7e6s4g', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', age: '', inquiry_type: '一般お問い合わせ', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            お問い合わせ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            ご質問やご相談がございましたら、お気軽にお問い合わせください。
            専門スタッフが丁寧にお答えいたします。
          </p>
        </div>

        <div className="flex justify-center">
          {/* お客様お問い合わせフォーム */}
          <div className="bg-gray-50 rounded-lg p-6 sm:p-8 max-w-2xl w-full">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
              ご相談・お問い合わせ
            </h3>
            
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">お名前 *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">メールアドレス *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">電話番号</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">年代</label>
                <div className="relative">
                  <select
                    name="age"
                    value={formData.age}
                    onChange={(e) => setFormData({...formData, age: e.target.value})}
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base appearance-none cursor-pointer"
                  >
                    <option value="">選択してください</option>
                    <option value="20代">20代</option>
                    <option value="30代">30代</option>
                    <option value="40代">40代</option>
                    <option value="50代">50代</option>
                    <option value="60代">60代</option>
                    <option value="70代以上">70代以上</option>
                  </select>
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">お問い合わせ種別 *</label>
                <div className="relative">
                  <select
                    name="inquiry_type"
                    value={formData.inquiry_type}
                    onChange={(e) => setFormData({...formData, inquiry_type: e.target.value})}
                    required
                    className="w-full px-3 sm:px-4 py-2 sm:py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base appearance-none cursor-pointer"
                  >
                    <option value="一般お問い合わせ">一般お問い合わせ</option>
                    <option value="ご予約について">ご予約について</option>
                    <option value="料金について">料金について</option>
                    <option value="施術内容について">施術内容について</option>
                    <option value="サロン加盟について">サロン加盟について</option>
                    <option value="その他">その他</option>
                  </select>
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <i className="ri-arrow-down-s-line text-gray-400"></i>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2 text-sm sm:text-base">お問い合わせ内容 *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base resize-vertical"
                  placeholder="お気軽にご相談ください（500文字以内）"
                ></textarea>
                <p className="text-gray-500 text-xs mt-1">{formData.message.length}/500文字</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting || formData.message.length > 500}
                className="w-full bg-amber-600 hover:bg-amber-700 disabled:bg-gray-400 text-white px-4 sm:px-6 py-3 sm:py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                {isSubmitting ? '送信中...' : 'お問い合わせを送信'}
              </button>

              {submitStatus === 'success' && (
                <div className="text-green-600 text-center font-semibold text-sm sm:text-base">
                  お問い合わせを受け付けました。ありがとうございます。
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="text-red-600 text-center font-semibold text-sm sm:text-base">
                  送信に失敗しました。もう一度お試しください。
                </div>
              )}
            </form>
          </div>
        </div>

        {/* 連絡先情報 */}
        <div className="mt-12 sm:mt-16 text-center bg-gray-50 rounded-lg p-6 sm:p-8">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">お電話でのお問い合わせ</h3>
          <div className="grid sm:grid-cols-2 gap-6 sm:gap-8">
            <div>
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-phone-line text-amber-600 text-xl sm:text-2xl"></i>
              </div>
              <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">0120-600-226</p>
              <p className="text-gray-600 text-sm sm:text-base">受付時間：平日 10:00〜17:00</p>
            </div>
            <div>
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <i className="ri-mail-line text-amber-600 text-xl sm:text-2xl"></i>
              </div>
              <p className="text-base sm:text-lg font-semibold text-gray-900 mb-2">info@densetsu-spa.com</p>
              <p className="text-gray-600 text-sm sm:text-base">メールでのお問い合わせも承っております</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
